// SR-CUSTOM: Block variant resolution until ALL options are selected.
//
// Shopify's Section Rendering API resolves ?option_values=X to the first
// available variant matching the partial selection. With only Size chosen,
// Detail Finish auto-fills with Brass, which then re-renders the picker with
// Brass checked and swaps the gallery to the variant image. We intercept the
// change event in the capture phase and stopImmediatePropagation() so that
// VariantSelects.onVariantChange never runs on partial selections. The hero
// image, "From $X" price, and "Choose size and finish" button all stay put.

(function () {
  function isPartialSelection(variantSelects) {
    var groups = variantSelects.querySelectorAll('fieldset, select');
    var selected = variantSelects.querySelectorAll('select option[selected], fieldset input:checked');
    return selected.length < groups.length;
  }

  function setChooseState(variantSelects) {
    var section = variantSelects.dataset.section;
    if (!section) return;
    var ids = [
      'product-form-' + section,
      'product-form-' + section + '-product-buy-bar'
    ];
    var miss = missing(variantSelects);
    ids.forEach(function (id) {
      var form = document.getElementById(id);
      if (!form) return;
      var btn = form.querySelector('[name="add"]');
      var btnText = form.querySelector('[name="add"] > span');
      if (btn) btn.setAttribute('disabled', 'disabled');
      if (btnText) btnText.textContent = miss.length ? chooseText(miss) : 'Choose size and finish';
    });
    if (variantSelects.dataset.updateUrl !== 'false' && window.history && window.history.replaceState) {
      try {
        window.history.replaceState({}, '', variantSelects.dataset.url);
      } catch (err) { /* noop */ }
    }
  }

  // The "Size:" / "Detail Finish:" line shows the choice straight away (19 Oct 2026). With only one option picked the theme's
  // re-render is blocked below, and the line is blank until then (snippets/product-variant-picker.liquid).
  function setLegend(target) {
    var fieldset = target.type === 'radio' && target.closest('fieldset');
    var legend = fieldset && fieldset.querySelector('[data-variant-legend]');
    if (legend) legend.textContent = target.value;
  }

  // "Coming Soon" products (tag; the hooks until launch), 19 Oct 2026: once a finish is clicked the theme's script writes
  // "Sold out" / "Unavailable" on the button (global.js toggleAddButton / setUnavailable). Put the launch text back, keep it disabled.
  // The buttons carry data-sr-coming-soon (block--product-buy-buttons / product-buy-bar); the bar's button is re-rendered on each change.
  function holdComingSoon() {
    var btns = document.querySelectorAll('button[data-sr-coming-soon]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (btn.srHeld) continue;
      btn.srHeld = true;
      var fix = (function (b) {
        return function () {
          var span = b.querySelector('span'), text = b.getAttribute('data-sr-coming-soon');
          if (span && span.textContent.trim() !== text) span.textContent = text;
          if (!b.disabled) b.disabled = true;
        };
      })(btn);
      new MutationObserver(fix).observe(btn, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      fix();
    }
  }
  function watchComingSoon() {
    if (!document.querySelector('button[data-sr-coming-soon]')) return;
    holdComingSoon();
    var bars = document.querySelectorAll('product-buy-bar');
    for (var i = 0; i < bars.length; i++) new MutationObserver(holdComingSoon).observe(bars[i], { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchComingSoon);
  else watchComingSoon();

  // ---- Helping customers choose first (David, 19 Oct 2026; design canvas row 5, "2"). Main product page only, not quick view.
  // While a size or finish is missing, the greyed button says which ("Choose a size" / "Choose a finish"), and a click on it
  // (main button or the sticky buy bar) scrolls to that option, flashes it, nudges its buttons and adds a short note under it.
  // A disabled button takes no clicks, so a clear button (.sr-choose-hit) is laid over it while it waits; the real button stays
  // disabled. window.SRChoose.point() is shared with the "Choose a size and finish" prompt on the photo (assets/sr-door-pdp.js),
  // which follows each pick through the 'sr:choice' event (partial picks never reach other change listeners: see below).
  // Styles: assets/sr-shortlist.css (loads on every page).
  function optionWord(fieldset) {
    var l = fieldset.querySelector('legend .option-label') || fieldset.querySelector('legend');
    var name = l ? l.textContent.split(':')[0].trim().toLowerCase() : '';
    return name.indexOf('finish') >= 0 ? 'finish' : name;   // "Detail Finish" reads as "finish"
  }
  function missing(variantSelects) {
    var out = [], sets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) if (!sets[i].querySelector('input:checked')) out.push(sets[i]);
    return out;
  }
  function chooseText(miss) {
    return miss.length > 1 ? 'Choose ' + miss.map(optionWord).join(' and ') : 'Choose a ' + optionWord(miss[0]);
  }
  function mainSelects() {
    var all = document.querySelectorAll('variant-selects');
    for (var i = 0; i < all.length; i++) {
      var v = all[i];
      if (v.dataset.modal !== 'true' && v.dataset.section && document.getElementById('product-form-' + v.dataset.section)) return v;
    }
    return null;
  }
  function addButtons(vs) {
    var out = [];
    ['product-form-' + vs.dataset.section, 'product-form-' + vs.dataset.section + '-product-buy-bar'].forEach(function (id) {
      var form = document.getElementById(id), btn = form && form.querySelector('[name="add"]');
      if (btn && btn.parentElement) out.push(btn);
    });
    return out;
  }
  var sizeWatch = 'ResizeObserver' in window ? new ResizeObserver(function () { sync(); }) : null;
  function cover(btn, on, label) {
    var host = btn.parentElement, hit = host.querySelector(':scope > .sr-choose-hit');
    if (!on) { if (hit) hit.hidden = true; return; }
    if (!hit) {
      hit = document.createElement('button');
      hit.type = 'button';
      hit.className = 'sr-choose-hit';
      hit.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); point(); });
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(hit);
      if (sizeWatch) sizeWatch.observe(btn);
    }
    hit.hidden = false;
    hit.setAttribute('aria-label', label);
    hit.style.left = btn.offsetLeft + 'px';
    hit.style.top = btn.offsetTop + 'px';
    hit.style.width = btn.offsetWidth + 'px';
    hit.style.height = btn.offsetHeight + 'px';
  }
  function sync() {
    var vs = mainSelects();
    if (!vs) return;
    var btns = addButtons(vs), miss = missing(vs);
    var soon = btns.some(function (b) { return b.hasAttribute('data-sr-coming-soon'); });
    var on = miss.length > 0 && !soon, label = miss.length ? chooseText(miss) : '';
    btns.forEach(function (b) { cover(b, on && b.disabled, label); });
  }
  function headerOffset() {
    var h = document.querySelector('header.header');
    return (h ? h.offsetHeight : 0) + 16;
  }
  var flashes = 0;
  function point() {
    var vs = mainSelects();
    if (!vs) return;
    var miss = missing(vs);
    if (!miss.length) return;
    var first = miss[0], r = first.getBoundingClientRect(), off = headerOffset();
    if (r.top < off || r.bottom > window.innerHeight - 16) {
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - off), behavior: calm ? 'auto' : 'smooth' });
    }
    flashes++;
    miss.forEach(function (fs) {
      fs.classList.remove('sr-flash-a', 'sr-flash-b');
      void fs.offsetWidth;
      fs.classList.add(flashes % 2 ? 'sr-flash-a' : 'sr-flash-b');
      var note = fs.querySelector(':scope > .sr-choose-note');
      if (!note) {
        note = document.createElement('p');
        note.className = 'sr-choose-note';
        note.setAttribute('role', 'status');
        fs.appendChild(note);
      }
      note.textContent = 'Choose a ' + optionWord(fs) + ' to continue';
    });
    var input = first.querySelector('input:not(.disabled)') || first.querySelector('input');
    if (input) { try { input.focus({ preventScroll: true }); } catch (err) { /* noop */ } }
  }
  window.SRChoose = { point: point, sync: sync };
  function announce(variantSelects) {
    var miss = missing(variantSelects).map(optionWord);
    try { document.dispatchEvent(new CustomEvent('sr:choice', { detail: { missing: miss } })); } catch (err) { /* noop */ }
  }
  // ---- A size's price straight away (David, 19 Oct 2026): picking a size before a finish shows that size's price instead of
  // "From $39.95" until both are chosen. Only when every finish costs the same at that size (true for all Ensemble handles today).
  // The price block is copied from the theme's own render of one matching variant (Section Rendering API, as the theme does for a
  // full choice), so the market's currency, trade prices and sale styling stay right.
  var productData = null, priceToken = 0;
  function productJson(vs) {
    if (!productData) {
      productData = fetch(vs.dataset.url + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .catch(function () { productData = null; return null; });
    }
    return productData;
  }
  function showPartialPrice(vs) {
    var token = ++priceToken, section = vs.dataset.section;
    if (!section || !document.getElementById('price-' + section)) return;
    var sets = vs.querySelectorAll('fieldset'), chosen = [];
    for (var i = 0; i < sets.length; i++) { var c = sets[i].querySelector('input:checked'); chosen.push(c ? c.value : null); }
    productJson(vs).then(function (p) {
      if (!p || !p.variants || token !== priceToken || !isPartialSelection(vs)) return;
      var matches = p.variants.filter(function (v) {
        return chosen.every(function (val, n) { return val === null || v.options[n] === val; });
      });
      if (!matches.length) return;
      var prices = {};
      matches.forEach(function (v) { prices[v.price] = true; });
      if (Object.keys(prices).length !== 1) return;     // the price depends on what's still missing: keep "From"
      var pick = matches.filter(function (v) { return v.available; })[0] || matches[0];
      return fetch(vs.dataset.url + '?variant=' + pick.id + '&section_id=' + encodeURIComponent(section), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (token !== priceToken || !isPartialSelection(vs)) return;
          var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('price-' + section);
          var cur = document.getElementById('price-' + section);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
    }).catch(function () { /* keep the "From" price */ });
  }

  function startChoose() {
    sync();
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startChoose);
  else startChoose();

  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var variantSelects = target.closest('variant-selects');
    if (!variantSelects) return;
    setLegend(target);
    var fieldset = target.closest('fieldset'), note = fieldset && fieldset.querySelector(':scope > .sr-choose-note');
    if (note) note.parentNode.removeChild(note);
    if (fieldset) fieldset.classList.remove('sr-flash-a', 'sr-flash-b');
    var partial = isPartialSelection(variantSelects);
    if (partial) {
      // Block VariantSelects.onVariantChange from firing.
      e.stopImmediatePropagation();
      setChooseState(variantSelects);
    }
    if (variantSelects === mainSelects()) {
      sync();
      announce(variantSelects);
      if (partial) showPartialPrice(variantSelects);
    }
  }, true); // capture: true — runs before the bubble-phase listener inside <variant-selects>
})();
